import { shallowRef } from 'vue'
import { DEFAUT_DENSITE, hauteurLigne, type DensiteTableau, type NiveauDensite } from './densite'

/**
 * Densité APPLIQUÉE au document, en état réactif : la seule partie de la
 * densité que le CSS ne peut pas porter. Les tableaux virtualisés positionnent
 * leurs lignes en JavaScript (`index × hauteur`) ; une hauteur de ligne posée en
 * CSS seulement décalerait le défilement, la sélection et le rendu des lignes
 * visibles.
 *
 * Écrite par `appliquer.ts` — et par lui seul — à chaque application de
 * l'apparence (cache, serveur, autre onglet, enregistrement). Lue par les
 * tableaux, qui se redimensionnent d'eux-mêmes quand elle change.
 */
export const densiteAppliquee = shallowRef<NiveauDensite>(DEFAUT_DENSITE)

/** Hauteur de ligne par défaut d'un tableau, selon la densité appliquée. */
export function hauteurLigneAppliquee(densiteTableau: DensiteTableau): number {
  return hauteurLigne(densiteAppliquee.value, densiteTableau)
}
